import { createMiddlewareAction } from "./createMiddlewareAction"
import { endpoints } from "../api/endpoints"
import { categoriesTypes } from "../constantes/actionTypes"

export const categoriesActions = {
    getAllCategories: () => (
        createMiddlewareAction({
            successType: categoriesTypes.GET_ALL_CATEGORIES_SUCCESS,
            failureType: categoriesTypes.GET_ALL__CATEGORIES_FAILURE,
            method: "GET",
            endpoint: endpoints.GET_ALL_CATEGORIES
        })
    ),
    newCategory: (category) => (
      createMiddlewareAction({
          successType: categoriesTypes.NEW_CATEGORY_SUCCESS,
          failureType: categoriesTypes.NEW_CATEGORY_FAILURE,
          method: "POST",
          endpoint: endpoints.NEW_CATEGORIES,
          body: category
      })
    ),
    updateCategory: (category) => (
      createMiddlewareAction({
          successType: categoriesTypes.UPDATE_CATEGORY_SUCCESS,
          failureType: categoriesTypes.UPDATE_CATEGORY_FAILURE,
          method: "PUT",
          endpoint: endpoints.UPDATE_CATEGORIES,
          body: category
      })
    ),
    deleteCategory: (idCategory) => (
      createMiddlewareAction({
          successType: categoriesTypes.DELETE_CATEGORY_SUCCESS,
          failureType: categoriesTypes.DELETE_CATEGORY_FAILURE,
          method: "DELETE",
          endpoint: endpoints.DELETE_CATEGORIES(idCategory),
      })
    ),
    
}